'use client';

import { FC, Fragment } from 'react';
import { useTranslations } from 'next-intl';
import { Building2, IdCard, BarChart3, Check, LucideIcon } from 'lucide-react';
import styles from './Calculator.module.scss';
interface CalculatorProps {
  progress: number;
}
type StepKey = 'business' | 'contact' | 'results';
const STEPS: Array<{
  key: StepKey;
  threshold: number;
  icon: LucideIcon;
  labelKey: string;
}> = [{
  key: 'business',
  threshold: 0,
  icon: Building2,
  labelKey: 'calculator.steps.businessInfo'
}, {
  key: 'contact',
  threshold: 50,
  icon: IdCard,
  labelKey: 'calculator.steps.contactDetails'
}, {
  key: 'results',
  threshold: 100,
  icon: BarChart3,
  labelKey: 'calculator.steps.savingsResults'
}];
export const Calculator: FC<CalculatorProps> = ({
  progress
}) => {
  const t = useTranslations();
  return <div className={styles.stepperBar} data-sentry-component="Calculator" data-sentry-source-file="Calculator.tsx">
            <div className={styles.stepperContainer}>
                {STEPS.map((step, index) => {
        const isCompleted = progress > step.threshold;
        const isActive = progress === step.threshold;
        const Icon = step.icon;
        const stateClass = isCompleted ? styles.stepCompleted : isActive ? styles.stepActive : '';
        return <Fragment key={step.key}>
                            <div className={`${styles.step} ${stateClass}`}>
                                <span className={styles.stepCircle}>
                                    {isCompleted ? <Check size={18} strokeWidth={2.5} /> : <Icon size={18} />}
                                </span>
                                <span className={styles.stepLabel}>
                                    {t(step.labelKey)}
                                </span>
                            </div>
                            {index < STEPS.length - 1 && <span className={`${styles.connector} ${progress > step.threshold ? styles.connectorActive : ''}`} />}
                        </Fragment>;
      })}
            </div>
        </div>;
};
export default Calculator;